import { useNavigate } from 'react-router-dom';
import { useProfile } from '@/hooks/useProfile';
import { isFeatureEnabled } from '@/config/featureFlags.service';
import { SIDE_NAV_SECTIONS } from '@/versions/v3/config/sideNavConfig';
import {
  TActionKey,
  TNavItemConfig,
  TNavSubItemConfig,
  TResolvedNavSection
} from '@/versions/v3/types/SideNav';

type TNavActions = Record<TActionKey, () => void>;

export const useSideNavSections = (actions: TNavActions): TResolvedNavSection[] => {
  const { accountType } = useProfile();
  const navigate = useNavigate();

  const isVisible = (item: TNavItemConfig | TNavSubItemConfig): boolean =>
    (!item.requiredAccountType || accountType === item.requiredAccountType) &&
    (!item.requiredFeature || isFeatureEnabled(item.requiredFeature));

  const resolveOnClick = (item: TNavItemConfig | TNavSubItemConfig): (() => void) | undefined => {
    if (item.route) return () => navigate(item.route!);
    if (item.actionKey) return actions[item.actionKey];
    return undefined;
  };

  return SIDE_NAV_SECTIONS.map((section) => ({
    ...section,
    items: section.items.filter(isVisible).map((item) => ({
      id: item.id,
      label: item.label,
      icon: item.icon,
      route: item.route,
      onClick: resolveOnClick(item),
      subItems: item.subItems?.filter(isVisible).map((sub) => ({
        id: sub.id,
        label: sub.label,
        route: sub.route,
        onClick: resolveOnClick(sub)
      }))
    }))
  })).filter((section) => section.items.length > 0);
};
